import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Dropzone from "react-dropzone";
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};
var iniActivity;

class ContentEdit extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        var data = props.Daatta.filter(function (d) {
            return d.contentId === props.rowId;
        });

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            data: data,
            ContentId: data[0].contentId,
            Activity_Id: data[0].activityId,
            Name: data[0].name,
            Information: data[0].information,
            Data: data[0].data,
            ContentType: data[0].contentType,
            Modifier: data[0].modifier,
            Modified: data[0].modified,
            activity: (Object.keys(props.lookupLists.activity).map((d) => ({ value: d, label: props.lookupLists.activity[d] })) || []),
        };

    }

    UNSAFE_componentWillMount() {
        iniActivity = this.state.activity.find(({ value }) => value === (this.state.Activity_Id || '').toString());
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            ContentId: this.state.data[0].contentId,
            Activity_Id: this.state.data[0].activityId,
            Name: this.state.data[0].name,
            Information: this.state.data[0].information,
            Data: this.state.data[0].data,
            ContentType: this.state.data[0].contentType,
            Modifier: this.state.data[0].modifier,
            Modified: this.state.data[0].modified
            
        });
    }

    handleSave = () => {
        this.props.onEditRow({
            ContentId: this.state.ContentId,
            Activity_Id: this.state.Activity_Id,
            Name: this.state.Name,
            Information: this.state.Information,
            Data: this.state.Data,
            ContentType: this.state.ContentType,
            Modifier: this.state.Modifier,
            Modified: this.state.Modified
            
        });

        this.handleClearData();
    }

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true })
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    handleFileDrop = (acceptedFiles) => {
        if (acceptedFiles.length === 0) {
            return
        }
        const file = acceptedFiles[0];
        const reader = new FileReader();
        reader.onload = () => {
            const base64 = reader.result.split(',')[1];

            this.setState({
                Data: base64,
                ContentType: file.type,
                FileName: file.name
            });
        };
        reader.readAsDataURL(file);
    }

    b64toBlob = async (b64Data, contentType) => {
        const response = await fetch(`data:${contentType};base64, ${b64Data}`);
        return await response.blob();
    }
    getLiite = async (liite) => {
        const blob = await this.b64toBlob(liite.blobdata, liite.type);
        const blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, "_blank");
    }

    render() {
        const { dictionary } = this.context;
        const { open, activity } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.Edit}>
                    <IconButton onClick={this.handleClickOpen}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Content.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                defaultValue={iniActivity}
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'Activity_Id')}
                                options={activity}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Content.Columns[1]} />}
                            />
                        </Box>
                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Content.Columns[2]}
                            type="text"
                            fullWidth
                            value={this.state.Name}
                            onChange={this.handleChange('Name')}
                        />
                        <TextField
                            margin="dense"
                            label={dictionary.Content.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Information}
                            onChange={this.handleChange('Information')}
                        />

                        <Dropzone
                            multiple={false}
                            onDrop={this.handleFileDrop}
                        >
                            {({ getRootProps, getInputProps }) => (
                                <div
                                    {...getRootProps()}
                                    style={{
                                        border: "2px dashed #3f51b5",
                                        borderRadius: 8,
                                        minHeight: 120,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cusor: "pointer"
                                    }}
                                >
                                    <input {...getInputProps()} />
                                    {this.state.FileName || "Drag & drop a file here or click "}
                                </div>

                            )}
                        </Dropzone>

                        <TextField
                            required
                            margin="dense"
                            label={dictionary.Content.Columns[5]}
                            type="text"
                            fullWidth
                            value={this.state.ContentType}
                            InputProps={{
                                readOnly: true
                            }}
                        //onChange={this.handleChange('ContentType')}
                        />
                        
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />

            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "ContentEdit" })(ContentEdit);
